import { API_ENDPOINT } from './env';

/**
 * Rails often returns path-only Active Storage URLs. The SPA runs on a different origin than the API,
 * so <img src="/rails/..."> would hit the dev server / CDN instead of Rails. Prefix relative paths with the API base.
 */
export function resolveApiAssetUrl(url: string | null | undefined): string | null {
  if (url == null || url === '') return null;
  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('blob:') || url.startsWith('data:')) return url;
  const path = url.startsWith('/') ? url : `/${url}`;
  return `${API_ENDPOINT.replace(/\/$/, '')}${path}`;
}
